<!-- pages.component.html -->
<!-- <h1>Welcome to the Pages Component</h1> -->
<router-outlet></router-outlet>

<!-- <ng-container *ngIf="countryfilter=='false'">
    {{countryfilter}}
    
    <div class="countryList-Container">
        <div class="country-Filter">
        
        <ul>
            <h3>Select Country</h3>

            <li *ngFor="let country of countryList">
                <div (click)="selectCountry(country)"><img [src]="getCountryFlag(country)" />
                    <span class="name">{{country}}</span><img src="assets/img/rightArrow.svg"  class="arrow"></div>
            </li>


            </ul>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="countryfilter=='true'">
    <router-outlet></router-outlet>
</ng-container> -->
